<template>
  <div class="f_content">
    <div class="f-container">
      <h2>Employee Birthdays</h2>
      <div v-show="pageLoading">
        <PageLoader />
      </div>
      <div v-if="birthdays.length === 0" class="no-birthdays">
        No birthdays to display.
      </div>
      <div v-else class="birthday-list">
        <div
          v-for="(birthday, index) in birthdays"
          :key="index"
          class="birthday-card"
        >
          <h3>{{ birthday[0] }}</h3>
          <p>{{ formatDate(birthday[1]) }}</p>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import * as types from "../../../store/constant";
import PageLoader from "../../partials/page-loader";
import BlueLoader from "../../partials/blue-loader";

export default {
  name: "Birthdays",
  components: {
    PageLoader,
    BlueLoader,
  },
  data() {
    return {
      employees: [],
      pageLoading: true,
      dataFetchError: false,
      dataSaveError: "",
      birthdays: [],
    };
  },

  created() {
    this.getEmployees();
  },

  methods: {
    formatDate(dateString) {
      const options = { year: "numeric", month: "long", day: "numeric" };
      return new Date(dateString).toLocaleDateString(undefined, options);
    },
    // formatDate(dateValue) {
    //   if (dateValue) {
    //     const date = new Date(dateValue);
    //     const months = [
    //       "January",
    //       "February",
    //       "March",
    //       "April",
    //       "May",
    //       "June",
    //       "July",
    //       "August",
    //       "September",
    //       "October",
    //       "November",
    //       "December",
    //     ];
    //     const days = [
    //       "Sunday",
    //       "Monday",
    //       "Tuesday",
    //       "Wednesday",
    //       "Thursday",
    //       "Friday",
    //       "Saturday",
    //     ];

    //     const monthName = months[date.getMonth()];
    //     const dayNumber = date.getDate();
    //     const dayName = days[date.getDay()];

    //     return `${dayName}, ${monthName} ${this.ordinalSuffix(dayNumber)}`;
    //   }
    // },

    // ordinalSuffix(dayNumber) {
    //   let percent = dayNumber % 10,
    //     k = dayNumber % 100;
    //   if (percent == 1 && k != 11) {
    //     return dayNumber + "st";
    //   }
    //   if (percent == 2 && k != 12) {
    //     return dayNumber + "nd";
    //   }
    //   if (percent == 3 && k != 13) {
    //     return dayNumber + "rd";
    //   }
    //   return dayNumber + "th";
    // },

    getEmployees() {
      this.$http
        .get(types.GET_BIRTHDAYS)
        .then((resp) => {
          this.birthdays = resp.data.data;
          console.log("just birthdays", this.birthdays);
          this.employees = resp.data.data.data;
          this.pagination = resp.data;
          this.pageLoading = false;
        })
        .catch((err) => {
          this.pageLoading = false;
          if (err.response) {
            this.dataFetchError = true;
          }
        });
    },

    viewEmployee(employee) {
      this.$router.push({ name: "viewEmployee", params: { id: employee.id } });
    },
  },
};
</script>

<style lang="scss" scoped>
.f_content {
  padding-top: 2rem;
}
.f-container {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
  text-align: center;
}

.f-container h2 {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 20px;
  color: #343a40;
}

.no-birthdays {
  font-size: 1.5rem;
  color: #6c757d;
}

.birthday-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.birthday-card {
  background-color: #ffffff;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
}

.birthday-card:hover {
  transform: translateY(-5px);
}

.birthday-card h3 {
  font-size: 1.5rem;
  margin: 0;
  color: #e57414;
  font-weight: 600;
}

.birthday-card p {
  font-size: 1rem;
  margin: 5px 0 0;
  color: #495057;
}
</style>
